import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./components/auth/Login";
import Signup from "./components/auth/Signup";
import Layout from "./components/sidebar/Layout";
import OnboardingSteps from "./components/auth/OnboardingSteps";
import ForgotPassword from "./components/auth/ForgotPassword";
import PasswordResetSuccess from "./components/auth/PasswordResetSuccess";
import NewPassword from "./components/auth/NewPassword";
import EmailVerification from "./components/auth/EmailVerification";
import WorkspaceReady from "./components/auth/WorkspaceReady";
import AuthLayout from "./components/layout/AuthLayout";
import Settings from "./components/dashboard/Settings";
import GoogleCallback from "./pages/GoogleCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import tokenManager from "./utils/tokenManager";
import TeamMemberSignup from "./components/auth/TeamMemberSignup";
import { UserProvider } from "./contexts/UserContext";
import Authorize from "./pages/Authorize";
import ProjectsPage from "./components/dashboard/ProjectsPage";
import VoiceLibraryPage from "./components/dashboard/VoiceLibraryPage";
import MusicLibraryPage from "./components/dashboard/MusicLibraryPage";

// Email components
import RecordingStudio from "./components/dashboard/RecordingStudio";
import SpeechIsolation from "./components/dashboard/SpeechIsolation";
import SettingsPage from "./components/dashboard/Settings";
import ProductGuard from "./components/ProductGuard";

function App() {
  return (
    <UserProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/onboarding/" element={<OnboardingSteps />} />
          <Route path="/workspace-ready" element={<WorkspaceReady />} />
          <Route path="/email-verification" element={<EmailVerification />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-success" element={<PasswordResetSuccess />} />
          <Route path="/new-password" element={<NewPassword />} />
          <Route path="/auth/google/callback" element={<GoogleCallback />} />
          <Route path="/invite/:token" element={<TeamMemberSignup />} />
          <Route path="/integrations/authorize" element={<Authorize />} />

          {/* Protected routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <ProductGuard
                  product="recording_studio"
                  crossAppUrl={process.env.REACT_APP_OCTOPUSH_X_URL}
                >
                  <Layout />
                </ProductGuard>
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="projects" replace />} />

            <Route path="/studio" element={<RecordingStudio />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/voice-library" element={<VoiceLibraryPage />} />
            <Route path="/speech" element={<SpeechIsolation />} />
            <Route path="/music-library" element={<MusicLibraryPage />} />

            {/* Email routes */}
          </Route>

          {/* Fallback route */}
          <Route path="*" element={<Navigate to="/projects" replace />} />
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
